import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  CM_BEGIN,
  CM_END,
  SET_ADS_DATA,
  MARK_VOD_AD_WATCHED,
  VOD_SAVE_LAST_POSITION,
  REQUEST_ADS_DATA,
  SET_ADS_PLAYING,
} from '../actions/types';
import { podTrackerAdsCmBeginReducer } from './cmBegin';
import { podTrackerAdsCmEndReducer } from './cmEnd';
import { podTrackerAdsSetAdsDataReducer } from './setAdsData';
import { podTrackerMarkVodAdWatchedReducer } from './markVodAdWatched';
import { podTrackerVodSaveLastPositionReducer } from './vodSaveLastPosition';
import { podTrackerRequestAdsDataReducer } from './requestAdsData';
import { podTrackerSetAdsPlayingActionReducer } from './setAdsPlaying';

export const defaultState = {
  adsData: {},
  viewedVodAdPods: {},
  vodLastPosition: {},
  continueWatching: [],
  isAdsPlaying: false,
  error: null,
};

export const podTrackerAdsReducer = createReducer(defaultState, {
  [SET_ADS_DATA]: podTrackerAdsSetAdsDataReducer,
  [REQUEST_ADS_DATA]: podTrackerRequestAdsDataReducer,
  [CM_BEGIN]: podTrackerAdsCmBeginReducer,
  [CM_END]: podTrackerAdsCmEndReducer,
  [MARK_VOD_AD_WATCHED]: podTrackerMarkVodAdWatchedReducer,
  [VOD_SAVE_LAST_POSITION]: podTrackerVodSaveLastPositionReducer,
  [SET_ADS_PLAYING]: podTrackerSetAdsPlayingActionReducer,
});
